(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function CategoryMenu(elem) {
        Behaviors.init(CategoryMenu, this, arguments);

        var $thisElem = this.$elem,
        dropdownButton = $thisElem.find('.CategoryMenu-dropdown_button');

        dropdownButton.on('click', function(e){
            e.preventDefault();
            e.stopPropagation();

            $thisElem.toggleClass('CategoryMenu--show_dropdown');
        });

        $(document).on('click', function(e){
            $thisElem.removeClass('CategoryMenu--show_dropdown');
        });

    }

    Behaviors.inherit(CategoryMenu, Behaviors.Behavior);

    CategoryMenu.QUERY = "[data-category-menu]";

    Behaviors.register_behavior(CategoryMenu);

    module.CategoryMenu = CategoryMenu;

    return module;

}(window.jQuery, window.Behaviors));